import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import "assets/css/bootstrap.min.css";
import "assets/scss/paper-kit.scss";
import "assets/demo/demo.css";
import "assets/demo/react-demo.css";
import "assets/css/ignitum-site.css";

import Approach from "views/Approach";
import ContactUs from "views/ContactUs";
import CurrentWork from "views/CurrentWork";
import Error404 from "views/Error404";
import FocusAreas from "views/FocusAreas";
import Index from "views/Index";
import SyntheticCognitionEngine from "views/SyntheticCognitionEngine";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter
    future={{
      v7_relativeSplatPath: true,
      v7_startTransition: true,
    }}
  >
    <Routes>
      <Route element={<Index />} path="/" />
      <Route element={<Navigate replace to="/" />} path="/index" />

      <Route element={<Approach />} path="/approach" />

      <Route element={<FocusAreas />} path="/focus-areas" />
      <Route element={<Navigate replace to="/focus-areas" />} path="/work" />

      <Route
        element={<SyntheticCognitionEngine />}
        path="/synthetic-cognition-engine"
      />
      <Route
        element={<Navigate replace to="/synthetic-cognition-engine" />}
        path="/sce"
      />

      <Route element={<CurrentWork />} path="/current-work" />

      <Route element={<Navigate replace to="/" />} path="/founder" />
      <Route element={<Navigate replace to="/" />} path="/about-us" />

      <Route element={<ContactUs />} path="/contact" />
      <Route element={<Navigate replace to="/contact" />} path="/contact-us" />

      <Route element={<Error404 />} path="/error-404" />
      <Route element={<Error404 />} path="*" />
    </Routes>
  </BrowserRouter>
);
